import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { CartContext } from '../context/CartContext';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { getTotalItems } = useContext(CartContext);
  const cartItems = getTotalItems();

  return (
    <nav className="bg-forest-green shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo and Brand */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/NorthPetLogo.png" 
              alt="NorthPet Inc. Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className="text-white text-2xl font-bold">NorthPet Inc.</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-8 items-center">
            <Link 
              to="/" 
              className="text-white hover:text-moss-green transition duration-300 text-lg font-medium"
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="text-white hover:text-moss-green transition duration-300 text-lg font-medium"
            >
              About
            </Link>
            <Link 
              to="/products" 
              className="text-white hover:text-moss-green transition duration-300 text-lg font-medium"
            >
              Products
            </Link>
            <Link 
              to="/wholesale" 
              className="text-white hover:text-moss-green transition duration-300 text-lg font-medium"
            >
              Wholesale
            </Link>
            
            {/* Cart Link */}
            <Link 
              to="/cart" 
              className="relative inline-block"
            >
              <button className="text-white hover:text-moss-green transition duration-300 flex items-center gap-2 bg-moss-green px-4 py-2 rounded-lg hover:bg-opacity-80">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>Cart</span>
                {cartItems > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center">
                    {cartItems}
                  </span>
                )}
              </button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center gap-4">
            {/* Mobile Cart Icon */}
            <Link 
              to="/cart"
              className="relative text-white"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
              {cartItems > 0 && (
                <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
                  {cartItems}
                </span>
              )}
            </Link>
            
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-moss-green focus:outline-none"
            >
              <svg 
                className="h-6 w-6" 
                fill="none" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth="2" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                {isOpen ? (
                  <path d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden pb-4">
            <Link 
              to="/" 
              className="block py-2 text-white hover:text-moss-green transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/about" 
              className="block py-2 text-white hover:text-moss-green transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/products" 
              className="block py-2 text-white hover:text-moss-green transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Products
            </Link>
            <Link 
              to="/wholesale" 
              className="block py-2 text-white hover:text-moss-green transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              Wholesale
            </Link>
            <Link 
              to="/cart" 
              className="block py-2 text-white hover:text-moss-green transition duration-300"
              onClick={() => setIsOpen(false)}
            >
              🛒 Cart {cartItems > 0 && `(${cartItems})`}
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
